"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var react_1 = __importStar(require("react"));
var getMediaRule = function (label, withoutMediaKey) {
    if (withoutMediaKey === void 0) { withoutMediaKey = false; }
    if (label[1])
        return "".concat(!withoutMediaKey ? '@media ' : '', "(min-width: ").concat(label[0], "px) and (max-width: ").concat(label[1], "px)");
    return "".concat(!withoutMediaKey ? '@media ' : '', "(min-width: ").concat(label[0], "px)");
};
var prepareQueries = function (keys, queries) {
    return keys.reduce(function (acc, key) {
        acc[key] = getMediaRule(queries[key], true);
        return acc;
    }, {});
};
var defaultValue = {
    mobile384: [0, 383],
    mobile460: [384, 459],
    mobile550: [460, 549],
    mobile660: [550, 659],
    mobile767: [660, 767],
    mobile: [0, 767],
    tablet: [768, 1279],
    l: [1280, 1439],
    xl: [1440],
};
var BreakpointContext = (0, react_1.createContext)(defaultValue);
var MediaQueriesProvider = function (_a) {
    var children = _a.children, _b = _a.queries, queries = _b === void 0 ? defaultValue : _b;
    var _c = (0, react_1.useState)({}), queryMatch = _c[0], setQueryMatch = _c[1];
    (0, react_1.useEffect)(function () {
        var mediaQueryLists = {};
        var keys = Object.keys(queries);
        var preparedQueries = prepareQueries(keys, queries);
        var isAttached = false;
        var handleQueryListener = function () {
            var updatedMatches = keys.reduce(function (acc, media) {
                acc[media] = mediaQueryLists[media] && mediaQueryLists[media].matches;
                return acc;
            }, {});
            setQueryMatch(updatedMatches);
        };
        if (window && window.matchMedia) {
            var matches_1 = {};
            keys.forEach(function (media) {
                if (typeof preparedQueries[media] === 'string') {
                    mediaQueryLists[media] = window.matchMedia(preparedQueries[media]);
                    matches_1[media] = mediaQueryLists[media].matches;
                }
                else {
                    matches_1[media] = false;
                }
            });
            setQueryMatch(matches_1);
            isAttached = true;
            keys.forEach(function (media) {
                if (typeof preparedQueries[media] === 'string') {
                    mediaQueryLists[media].addListener(handleQueryListener);
                }
            });
        }
        return function () {
            if (isAttached) {
                keys.forEach(function (media) {
                    if (typeof preparedQueries[media] === 'string') {
                        mediaQueryLists[media].removeListener(handleQueryListener);
                    }
                });
            }
        };
    }, [queries]);
    return (react_1.default.createElement(BreakpointContext.Provider, { value: queryMatch }, children));
};
function useBreakpoint() {
    var context = (0, react_1.useContext)(BreakpointContext);
    if (context === defaultValue) {
        // throw new Error('useBreakpoint must be used within MediaQueriesProvider');
        return {};
    }
    return context;
}
exports.useBreakpoint = useBreakpoint;
exports.default = MediaQueriesProvider;
